import { getBooks, getFeaturedBooks } from "../../api/books";
import { createSliceWithThunks } from "../utils";

const initialState = {
  get: {
    list: null,
    error: null,
    status: "idle",
  },
  post: {
    data: null,
    error: null,
    status: "idle",
  },
  put: {
    data: null,
    error: null,
    status: "idle",
  },
  featured: {
    list: null,
    error: null,
    status: null,
  },
};

export const bookSlice = createSliceWithThunks({
  name: "books",
  initialState: initialState,
  reducers: (create) => ({
    resetStateBooks: create.reducer((state, { payload }) => {
      if (payload) {
        for (let key in payload) {
          state[`${payload[key]}`] = initialState[`${payload[key]}`];
        }
      } else {
        for (let key in initialState) {
          state[key] = initialState[key];
        }
      }
    }),

    fetchBooks: create.asyncThunk(
      async (payload, { rejectWithValue }) => {
        try {
          const response = await getBooks(payload);
          return response;
        } catch (err) {
          return rejectWithValue(err.message);
        }
      },
      {
        pending: (state) => {
          state.get.status = "loading";
        },
        rejected: (state, action) => {
          state.get.status = "failed";
          state.get.error = action.error;
        },
        fulfilled: (state, { payload }) => {
          const { status, data } = payload;
          if (status === 200) {
            let { status, data: respObj } = data;
            if (status === "error") {
              state.get.error = { message: respObj };
            } else if (status === "success") {
              state.get.list = respObj;
            }
          } else {
            state.get.error = {
              message: data?.message || "An error occurred",
            };
          }
          state.get.status = "idle";
        },
      }
    ),

    fetchFeaturedBooks: create.asyncThunk(
      async (payload, { rejectWithValue }) => {
        try {
          const response = await getFeaturedBooks(payload);
          return response;
        } catch (err) {
          return rejectWithValue(err.message);
        }
      },
      {
        pending: (state) => {
          state.featured.status = "loading";
        },
        rejected: (state, action) => {
          state.featured.status = "failed";
          state.featured.error = action.error;
        },
        fulfilled: (state, { payload }) => {
          const { status, data } = payload;
          if (status === 200) {
            let { status, data: respObj } = data;
            if (status === "error") {
              state.featured.error = { message: respObj };
            } else if (status === "success") {
              state.featured.list = respObj;
            }
          } else {
            state.featured.error = {
              message: data?.message || "An error occurred",
            };
          }
          state.featured.status = "idle";
        },
      }
    ),
  }),
});

export const { resetStateBooks, fetchBooks, fetchFeaturedBooks} = bookSlice.actions;
export default bookSlice.reducer;
